const moduleName = 'promo';

const TypeIt = require('typeit');

module.exports = () => {

	Array.from(document.querySelectorAll('.js-promo')).forEach((self) => {
		if (self.dataset[moduleName + 'Init'] === 'true') return;
		self.dataset[moduleName + 'Init'] = true;

		const holder = self;
		const firstStrings = holder.querySelectorAll('.js-promo-first-string');
		const secondStrings = holder.querySelectorAll('.js-promo-second-string');
		const caption = holder.querySelector('.js-promo-caption');
		const text = holder.querySelector('.js-promo-text');
		const captions = [];
		const texts = [];

		Array.from(firstStrings).forEach((string) => captions.push(string.innerHTML));
		Array.from(secondStrings).forEach((string) => texts.push(string.innerHTML));



		initTypers(0);



		function initTypers(num) {
			let captionTypeIt;
			let textTypeIt;

			caption.classList.remove('_hidden');
			caption.classList.remove('_no-cursor');
			text.classList.remove('_hidden');

			captionTypeIt = new TypeIt(caption, {
				strings: captions[num],
				speed: 100,
				afterString: (step, quene, instance) => {
					instance.freeze();
					caption.classList.add('_no-cursor');

					if (!textTypeIt.hasStarted) {
						textTypeIt.init();
					} else {
						textTypeIt.unfreeze();
					}
				}
			});

			textTypeIt = new TypeIt(text, {
				strings: texts[num],
				speed: 75,
				afterString: (step, quene, instance) => {
					instance.freeze();
					caption.classList.add('_hidden');
					text.classList.add('_hidden');

					setTimeout(() => {
						captionTypeIt.destroy();
						instance.destroy();

						if (num != captions.length - 1) {
							initTypers(num + 1);
						} else {
							initTypers(0);
						}
						
					}, 3000);
				}
			}, false);
		}
	});

};